import React from "react";
import DefaultImage from "./Default.png";
import MarkerImage from "./Marker.png";
import GreenMarker from "./GreenMarker.png";
import RedMarker from "./RedMarker.png";
import YellowMarker from "./YellowMarker.png";
import Style from "../../styles/js/Styles";
import { Marker } from "react-leaflet";
import L from "leaflet";

const IsolatedMarker = (props: any) => {
  const { name, id } = props;

  const style = Style();

  const getCirclePath = (photoUrl) => {
    if (photoUrl != undefined) {
      if (photoUrl.endsWith("photo.jpg")) {
        var splitted = photoUrl.split("/");
        splitted[splitted.length - 2] = "s76-cc-rp";
        return splitted.join("/");
      } else {
        return photoUrl.split("=")[0].concat("=s76-cc-rp");
      }
    }
  };

  if (props.userState.profile !== undefined) {
    var photoUrl =
      props.userState.profile.photoUrl !== undefined
        ? getCirclePath(props.userState.profile.photoUrl)
        : DefaultImage;

    var background = props.userState.isMoving()
      ? RedMarker
      : !props.userState.hasLocation() || props.userState.isOutDated()
      ? MarkerImage
      : props.userState.isUpdated()
      ? GreenMarker
      : YellowMarker;

    return (
      <div>
        <Marker
          className={style.marker}
          position={[props.lat, props.lng]}
          icon={
            new L.Icon({
              iconUrl: background,
              iconSize: [45, 47],
              iconAnchor: new L.Point(22.5, 47),
            })
          }
          eventHandlers={{
            click: (e) => {
              props.clickcall(props.userState);
            },
          }}
        />

        <Marker
          className={style.marker}
          position={[props.lat, props.lng]}
          icon={
            new L.Icon({
              iconUrl: photoUrl,
              iconSize: [31, 31],
              iconAnchor: new L.Point(15, 40),
            })
          }
          eventHandlers={{
            click: (e) => {
              props.clickcall(props.userState);
            },
          }}
        />
      </div>
    );
  }
};

export default IsolatedMarker;
